import { Product, SUBSCRIPTION_PERIOD } from '../constants/config';
import { useEffect, useState } from 'react';
import { getPlansPrices } from '../services/fastspringService';
import { getPriceWithDiscount } from '../components/Plan/planUtils';
import { pickProperty } from '../utils/helpers';
import { Promo } from '../components/Promo/types';

type PlanData = {
  getPrice(plan): {
    monthlyPrice: number;
    yearlyMonthlyPrice: number;
    currencySymbol: string;
  };
};

const INITIAL_VALUE = {
  discount: 0,
  currencySymbol: '$',
};

export const useMaxDiscount = (getDiscount: Promo['getDiscount'], products, user) => {
  const [plansData, setPlansData] = useState<PlanData>();

  useEffect(() => {
    getPlansPrices().then(setPlansData);
  }, []);

  if (!plansData) return INITIAL_VALUE;
  const { subscription: { plan = 0, interval = SUBSCRIPTION_PERIOD.MONTHLY } = {} } = user || {};

  const filteredProducts: Product[] = products.filter(pickProperty('planId'));

  const delta = filteredProducts.map((product) => {
    const { monthlyPrice, yearlyMonthlyPrice, currencySymbol } = plansData.getPrice(product);

    const yearlyDiscount = getDiscount(
      { planId: plan, interval },
      { planId: product.planId, interval: SUBSCRIPTION_PERIOD.YEARLY },
    );
    return {
      discount: monthlyPrice - getPriceWithDiscount(yearlyMonthlyPrice, yearlyDiscount),
      currencySymbol,
    };
  });

  const max = delta.reduce(
    (acc, item) => (acc.discount < item.discount ? item : acc),
    INITIAL_VALUE,
  );

  return {
    discount: (max.discount * 12) | 0,
    currencySymbol: max.currencySymbol,
  };
};
